import { render } from "./CorporateBondsPage.vue?vue&type=template&id=718a4da0"
import script from "./CorporateBondsPage.vue?vue&type=script&lang=js"
export * from "./CorporateBondsPage.vue?vue&type=script&lang=js"

import "./CorporateBondsPage.vue?vue&type=style&index=0&id=718a4da0&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__